export default __webpack_public_path__ + "images/f9794382ca1bdc1c195ed7109743ff21-supportAgent.svg";